<template>
  <ViewTransition>
    <div id="gtm-campaign" class="Campaign">
      <CampaignHeader :title="dataMain.name" />

      <div id="headerCampana">
        <div class="tituloHeader">
          <h1>
            <small>
              {{ model.header.titleSmall }}
            </small>
            {{ model.header.title }}
            <br />
            {{ model.header.title2 }}
          </h1>
        </div>
        <div class="texto">
          <p v-html="model.header.parrafo"></p>
          <h3 class="rf">
            {{ model.header.footer }}
          </h3>
        </div>
        <img :src="images.imgBotella" alt="Carta Blanca" />
      </div>
      <VideoFull
        v-if="isDesktop"
        :videoUrl="videosC.webmc"
        :playable="true"
        @pause="onPause"
        @play="onPlay"
        @ended="onEnd"
        embed
        :width="1920"
        :height="1080"
      />

      <VideoFull
        v-if="isMobile"
        :videoUrl="videosC.videoc"       
        :playable="true"
        @pause="onPause"
        @play="onPlay"
        @ended="onEnd"
        embed
        :width="1920"
        :height="1080"
      />
    </div>
  </ViewTransition>
</template>

<script>
import ViewTransition from "@/transitions/ViewTransition.vue";
import CampaignHeader from "@/components/CampaignHeader";
import VideoFull from "@/components/VideoFull";
import model from "@/data/campaign.json";
import gsap, { TweenMax } from "gsap";
import { videos, images, videosInterior } from "@/data/campaignImages";
import TagFunctions from "@/assets/tagFunctions.js";

  let timer, percent = 0, quartileTime
function record(event) {
  let currentTime = Math.round(event.currentTime);
  let totalTime = event.duration
  percent = getPercent(event);

  if (currentTime == quartileTime) {
    TagFunctions.evVideoPush(
      event.title,
      "Reach",
      "25",
      totalTime,
      "NA"
    );
  }

  if (currentTime == 2 * quartileTime) {
    TagFunctions.evVideoPush(
      event.title,
      "Reach",
      "50",
      totalTime, 
      "NA"
    );
  }
  if (currentTime == 3 * quartileTime) {
    TagFunctions.evVideoPush(
      event.title,
      "Reach",
      "75",
      totalTime,
      "NA"
    );
  }

  if (currentTime == Math.round(event.duration * 0.99)) {
    TagFunctions.evVideoPush(
      event.title,
      "Reach",
      "100",
      totalTime,
      "NA"
    );
  }

  function getPercent(event) {
    return Math.round(
      (event.currentTime / event.duration) * 100
    );
  }
}
  function onPlayerStateChange(event, state) {
  let totalTime = event.duration
  quartileTime = Math.round(event.duration / 4);
  const getQuartile = () => {
    if (percent <= 25) return 25;
    else if (percent > 25 && percent <= 50) return 50;
    else if (percent > 50 && percent <= 75) return 75;
    else return 100;
  };

  if (state == 'PLAYING') {
    TagFunctions.evVideoPush(event.title, "Play", getQuartile(), totalTime, "NA")
    
    timer = setInterval(() => {
      record(event);
    }, 900);
  } else {
    clearInterval(timer);
  }

  if (state == 'ENDED') {
    TagFunctions.evVideoPush(event.title, "Complete", getQuartile(), totalTime, "NA")
    
  }

  if (state == 'PAUSED') {
    TagFunctions.evVideoPush(event.title, "Pause", getQuartile(), totalTime, "NA")
    
  }
}


export default {
  name: "Campaign",
  components: {
    ViewTransition,
    CampaignHeader,
    VideoFull,
  },
  data: () => ({
    model,
    videos,
    images,
    active: 0,
    prevActive: 0,
    nextActive: 1,
    animDirection: "right",
    poster: require("@/assets/img/campaign/poster.jpg"),
    videosInterior,
    isMobile: false,
    isDesktop: false,
    videosC: {
      webmc: require("@/assets/videos/homeNew_web.mp4"),
      videoc: require("@/assets/videos/homeNew_video.mp4"),
    },
  }),
  mounted() {
    this.prevActive = this.slides.length - 1;
    TagFunctions.evPagePush('Campaña')
  },
  computed: {
    dataMain() {
      return this.model.home;
    },
    slides() {
      return this.model.slides;
    },
    slidesBg() {
      const { dataMain } = this;
      return dataMain.slidesBg;
    },
    isDesktop() {
      return window.innerWidth >= 1100;
    },
    height() {
      return window.innerHeight;
    },
  },
  created() {
    this.updateVideoSource();
    console.log("created");
    window.addEventListener("resize", () => {
      console.log("xxxxxx");
      this.updateVideoSource();
    });
  },
  methods: {
    updateVideoSource() {
      this.isMobile = false;
      this.isDesktop =false;
      setTimeout(() => {
        if (window.innerWidth > 768) {
          this.isDesktop = true;
          this.isMobile = false;
        } else {
          this.isDesktop = false;
          this.isMobile = true;
        }
      },500);
    },
    onPlay(video) {
      const { $refs } = this;
      gsap.to($refs.cta, 0.5, { opacity: 0, ease: "power3.inOut" });
      onPlayerStateChange(video, 'PLAYING')
    },
    onPause(video) {
      const { $refs } = this;
      gsap.to($refs.cta, 0.5, { opacity: 1, ease: "power3.out" });
      onPlayerStateChange(video, 'PAUSED')
    },
    onEnd(video){
      onPlayerStateChange(video, 'ENDED')
    },
    explore() {
      const { height } = this;
      const elems = [document.body, document.documentElement];

      TweenMax.to(elems, 0.5, {
        scrollTop: height,
        ease: "power2.easeInOut",
      });
    },
    handleSwipe(ev) {
      if (ev.type == "swipeleft") this.back("right");
      else this.next("left");
    },
    back(dir = "left") {
      const { active, slides } = this;
      const _active = active == 0 ? slides.length - 1 : active - 1;
      this.animDirection = dir;
      this.prevActive = active;
      this.nextActive = _active == 0 ? slides.length - 1 : _active - 1;
      this.active = _active;
    },
    next(dir = "right") {
      const { active, slides } = this;
      const _active = active == slides.length - 1 ? 0 : active + 1;
      this.animDirection = dir;
      this.prevActive = active;
      this.nextActive = _active == slides.length - 1 ? 0 : _active + 1;
      this.active = _active;
    },
    hideModal() {
      const { $refs } = this;
      gsap.to($refs.modal, 0.75, {
        opacity: 0,
        ease: "power3.inOut",
        onComplete: () => {
          gsap.set($refs.modal, { display: "none" });
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './Campaign.styl';
</style>
